import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'
import { ComponentProps } from 'react'

export default function ViverseSkeleton({ className, ...props }: ComponentProps<typeof Skeleton>) {
  return (
    <Skeleton
      className={cn('bg-transparent bg-linear-to-tr from-slate-500/10 to-gray-800/10', className)}
      {...props}
    />
  )
}
